// extracted by mini-css-extract-plugin
export default {"nav":"Navbar_nav__OhzX+","div1":"Navbar_div1__FlgGb","acc":"Navbar_acc__lib5Z","btn":"Navbar_btn__X27gs","btn1":"Navbar_btn1__eqmIT"};